angular.module('cvsApp').factory('errorModel',['msgManagerService',function(MMS) {	
	'use strict';
	var errorModel = function(){

		var error;
		var errordata = {};
		var errorKey="";
		var refId = "";
		this.Error = function(data){
			error=data;	
		};	

		this.getError = function(){
			return error;		
		};

		this.setErrorKey = function(key){			
			errorKey = key;
		}

		this.getErrorKey = function(){
			return errorKey;
		}

		this.getErrorData = function(errorKey){
			return MMS.errorMsg(errorKey);
		}

		this.setRefId = function(errorRefId){
			refId = errorRefId;
		}
		this.getRefId = function(){
			return refId;
		}

		
	};
	
	return new errorModel();
}]);